module.exports = "../../app/cells/components/campaigns/interventions/leaderboard/show.erb";